import { Search } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import React from "react";

interface SearchInputProps {
  label: string;
  onSearch: (filter: string) => void;
  onChangeFilter: (filter: string) => void;
  value?: string;
  isLoading?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  label,
  onSearch,
  onChangeFilter,
  value = "",
  isLoading = false,
}) => {
  const [filter, setFilter] = React.useState(value);

  React.useEffect(() => {
    setFilter(value);
  }, [value]);

  const handleSearch = () => {
    onSearch(filter);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFilter = event.target.value;
    setFilter(newFilter);
    onChangeFilter(newFilter);
  };

  return (
    <Box
      width={{ xs: "100%", sm: "auto" }}
    >
      <TextField
        id="search"
        size="small"
        label={label}
        variant="filled"
        value={filter}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        fullWidth
        InputLabelProps={{
          sx: (theme) => ({
            maxWidth: "calc(100% - 60px)",
            paddingLeft: theme.spacing(1),
            color: theme.palette.text.secondary,
            "&.Mui-focused": {
              color: theme.palette.primary.main,
            },
          }),
        }}
        InputProps={{
          disableUnderline: true,
          sx: (theme) => ({
            borderRadius: 28,
            backgroundColor: theme.palette.surfaceContainerHigh,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
          }),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                title="Buscar"
                aria-label="search"
                size="medium"
                color="default"
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                  transition: theme.transitions.create("color"),
                  "&:hover": {
                    color: theme.palette.primary.main,
                  },
                })}
                onClick={handleSearch}
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Search />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
